"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (window) {
  var Globals = /*#__PURE__*/function () {
    function Globals() {
      _classCallCheck(this, Globals);

      throw new window.Error("You can't create instances of the class [Globals]. Please, use the static methods.");
    }
    /*
     *   Events
     */


    _createClass(Globals, null, [{
      key: "checkCookieBeforeUsingCart",
      value: function checkCookieBeforeUsingCart() {
        if (!navigator.cookieEnabled) {
          $(window).triggerHandler(window.HelperModal.CLASSNAME + ".show", [{
            theme: window.AbstractBootstrapModal.THEME_DANGER,
            closeBtn: true,
            header: window.theme.strings.helper_modal.disabled_cookie.title,
            body: window.theme.strings.helper_modal.disabled_cookie.body_html
          }]);
          return false;
        }

        return true;
      }
    }, {
      key: "preventScrollOnDropdown",
      value: function preventScrollOnDropdown(selector) {
        var $sel = $(selector);

        if ($sel.find(".dropdown-menu")[0].scrollHeight <= $sel.find(".dropdown-menu")[0].clientHeight) {
          // doesn't have a scrollable content: do nothing
          return;
        }

        $sel.off("shown.bs.dropdown.prevent_scroll_on_dropdown").on("shown.bs.dropdown.prevent_scroll_on_dropdown", function (event) {
          $sel.find(".dropdown-menu").off("pointerleave.prevent_scroll_on_dropdown pointerenter.prevent_scroll_on_dropdown").on("pointerleave.prevent_scroll_on_dropdown pointerenter.prevent_scroll_on_dropdown", function (event) {
            Globals.bodyScrollEnabled = !(event.type == "pointerenter");
          });
        });
        $sel.find(".dropdown-menu").off("hide.bs.dropdown.prevent_scroll_on_dropdown").on("hide.bs.dropdown.prevent_scroll_on_dropdown", function (event) {
          Globals.bodyScrollEnabled = true;
          $sel.off("pointerleave.prevent_scroll_on_dropdown pointerenter.prevent_scroll_on_dropdown");
        });
      }
    }, {
      key: "checkoutQuantityLiveUpdate",
      value: function checkoutQuantityLiveUpdate() {
        var CART_DATA = [];

        for (var i = 0; i < Globals.variants.length; i++) {
          CART_DATA.push({
            product_id: Globals.variants[i].product_id,
            variant_id: Globals.variants[i].variant_id,
            variant_options: Globals.variants[i].variant_options
          });
        }

        var live_url = "https://ws.space23.it/availabilities/multiple/liveup";
        console.log('host', window.location.host);

        if (window.location.host.indexOf('space23staging') > -1) {
          live_url = "https://staging-ws.space23.it/availabilities/multiple/liveup";
        }

        console.log('live_url', live_url);
        $.ajax({
          method: "POST",
          url: live_url,
          data: {
            cart: CART_DATA
          }
        }).done(function (response) {
          console.log("Redirect to checkout ok:", response);
        }).fail(function (response) {
          console.log("Redirect to checkout fail:", response);
        }).always(function (response) {
          console.log("------------> Redirect to checkout always: ", response); // window.location.href = "/checkout";
        });
        window.location.href = "/checkout";
      }
    }, {
      key: "pushBeginCheckoutDataLayer",
      value: function pushBeginCheckoutDataLayer() {
        console.log('------> pushBeginCheckoutDataLayer');
        console.log('CART_ITEMS', Globals.CART_ITEMS);
        /* console.log('dataLayerPush', {
            event: "begin_checkout",
            ecommerce: {
            items: Globals.CART_ITEMS
            }
        }); */

        dataLayer.push({
          ecommerce: null
        });
        dataLayer.push({
          event: "begin_checkout",
          ecommerce: {
            items: Globals.CART_ITEMS
          }
        });
      }
    }, {
      key: "updateVariants",
      value: function updateVariants(data) {
        if (data.items) {
          //all the cart
          Globals._variants = [];

          for (var i = 0; i < data.items.length; i++) {
            var _clone = $.extend(true, data.items[i], {});

            Globals._variants.push(_clone);
          }
        } else {
          if (!Globals._variants) {
            Globals._variants = [];
          } // a new item in the cart


          var _clone2 = $.extend(true, data, {});

          Globals._variants.push(_clone2);
        }
      }
      /*static updateVariants(data) {
           if (data.items) {
               //all the cart
               if (Globals._variants) {
                  for (let i = 0; i < Globals._variants.length; i++) {
                      Globals._variants[i]._variantsAjax.abort();
                      Globals._variants[i]._variantsAjax = null;
                  }
              }
               Globals._variants = [];
               for (let i = 0; i < data.items.length; i++) {
                   let _clone = $.extend(true, data.items[i], {});
                   Globals._variants.push(_clone);
                   _clone._variantsAjax = $.ajax({
                      dataType: "json",
                      url: "https://ws.space23.it/variant/" + data.items[i].variant_id + "/t",
                      success: onVariantSuccess.bind(_clone),
                      error: onVariantError.bind(_clone)
                  });
              }
           } else {
               // a new item in the cart
               if (!Globals._variants) {
                  Globals._variants = [];
              }
               let _clone = $.extend(true, data, {});
               Globals._variants.push(_clone);
               _clone._variantsAjax = $.ajax({
                  dataType: "json",
                  url: "https://ws.space23.it/variant/" + data.variant_id + "/t",
                  success: onVariantSuccess.bind(_clone),
                  error: onVariantError.bind(_clone)
              });
          }
           function onVariantSuccess(response) {
               if (response.response == "error") {
                  console.warn(response);
                  return;
              }
               if (response.tags.match("onlyone") || response.max_quantity == 1) {
                  response.max_quantity = 1;
                  response.onlyone = true;
                  response.available_for_user = 0;
              } else {
                  response.onlyone = false;
                  response.max_quantity = response.max_quantity;
                  response.available_for_user = response.max_quantity - this.quantity;
              }
               this.variant_data = response;
               $(window).trigger(Globals.VARIANT_UPDATED, [this]);
               const N_VARIANTS_LOADED = $(Globals._variants).filter((index, item) => {
                  return item.variant_data
              }).length;
               if (N_VARIANTS_LOADED == Globals._variants.length) {
                  $(window).trigger(Globals.ALL_VARIANTS_UPDATED, [Globals._variants]);
              }
          }
           function onVariantError(response) {
          //     console.warn("onVariantError:", response);
          // }
      }
      */

    }, {
      key: "isVariantInCart",
      value: function isVariantInCart(variantId) {
        return _.filter(Globals.variants, function (v) {
          return v.id == variantId;
        }).length > 0;
      }
      /*
       *   Alerts
       */

    }, {
      key: "IS_QUICK_PRODUCT_AUTHORIZED_DEVICE_TYPE",
      get: function get() {
        return window.Detectizr.device.type.match("mobile|tablet");
      }
    }, {
      key: "VARIANT_UPDATED",
      get: function get() {
        return "globals__variant_updated";
      }
    }, {
      key: "ALL_VARIANTS_UPDATED",
      get: function get() {
        return "globals__all_variants_updated";
      }
    }, {
      key: "BODY_SCROLL_ENABLED_CHANGE",
      get: function get() {
        return "body-scroll-enabled-change";
      }
      /*
       *   Methods
       */

    }, {
      key: "bodyScrollEnabled",
      set: function set(b) {
        if (window.Detectizr.os.name.match("ios") && window.Detectizr.browser.name.match("safari")) {
          if (b) {
            $("html, body").removeAttr("touch-action");
          } else {
            $("html, body").attr("touch-action", "none");
          }
        }

        if (b) {
          $("html, body").removeClass("disable-native-scrolling");
        } else {
          $("html, body").addClass("disable-native-scrolling");
        }

        Globals._bodyScrollEnabled = b;
        $(window).trigger(Globals.BODY_SCROLL_ENABLED_CHANGE, [b]);
      },
      get: function get() {
        if (Globals._bodyScrollEnabled === undefined) {
          Globals._bodyScrollEnabled = !$("body").hasClass("disable-native-scrolling");
        }

        return Globals._bodyScrollEnabled;
      }
    }, {
      key: "moneyFormat",
      get: function get() {
        if (!Globals._moneyFormat) {
          Globals._moneyFormat = $("body").attr("data-money-format");
        }

        return Globals._moneyFormat;
      }
    }, {
      key: "CART_URL",
      get: function get() {
        return "/cart.js";
      }
    }, {
      key: "CART_ADD_URL",
      get: function get() {
        return "/cart/add.js";
      }
    }, {
      key: "CART_CHANGE_URL",
      get: function get() {
        return "/cart/change.js";
      }
    }, {
      key: "CART_UPDATE_URL",
      get: function get() {
        return "/cart/update.js";
      }
    }, {
      key: "SEARCH_URL",
      get: function get() {
        return "/search";
      }
    }, {
      key: "variants",
      get: function get() {
        return Globals._variants;
      }
    }, {
      key: "PRODUCT_ALREADY_IN_CART",
      get: function get() {
        return "This product is already in the cart.";
      }
    }, {
      key: "CAN_ONLY_BUY_ONE",
      get: function get() {
        return "Sorry, you can only buy one product of this type.";
      }
    }, {
      key: "REQUESTED_QUANTITY_IS_NOT_AVAILABLE",
      get: function get() {
        return "Sorry, the requested quantity is not available. REQUESTED=$requested, AVAILABLE=$available";
      }
    }, {
      key: "CAN_PURCHASE_ONLY_NUM",
      get: function get() {
        return "Sorry, you can purchase only $num items for this variant.";
      }
    }]);

    return Globals;
  }();

  window.Globals = Globals;
})(window);
